import { useEffect, useMemo } from 'react'
import { useLingui } from '@lingui/react'
import { z } from 'zod'

import { Tab, Tabs } from '@mui/material'

import { useQueryParam } from '@/hooks/useQueryParam'
import { t } from '@lingui/macro'

export enum EstablishmentTabEnum {
  ADMIN = 'admin',
  STAFF = 'staff',
}

function validateEstablishmentTab(value: string | null) {
  return z.nativeEnum(EstablishmentTabEnum).catch(EstablishmentTabEnum.ADMIN).parse(value)
}

export function useEstablishmentTab() {
  const [tab] = useQueryParam('tab', validateEstablishmentTab)
  return tab
}

export function EstablishmentTabs() {
  const lingui = useLingui()

  const [tab, setTab] = useQueryParam('tab', validateEstablishmentTab)

  const tabs = useMemo(
    () => [
      { id: 'admin', label: lingui._(t`Admin`), value: EstablishmentTabEnum.ADMIN },
      { id: 'staff', label: lingui._(t`Staffs`), value: EstablishmentTabEnum.STAFF },
    ],
    [lingui]
  )

  return (
    <Tabs value={tab} onChange={(_event, newValue) => setTab(newValue)} variant="scrollable">
      {tabs.map((tab) => (
        <Tab key={tab.id} label={tab.label} value={tab.value} />
      ))}
    </Tabs>
  )
}
